import { Pipe, PipeTransform } from '@angular/core';
import { InitiatorType, TransactionType } from 'common';
import { TransactionData } from './transaction.model';

export interface TransactionAvatar {
  letter: string;
  cssClass: string;
  tooltip?: string;
  tooltipClass?: string;
}

@Pipe({
    name: 'transactionAvatar',
    standalone: false
})
export class TransactionAvatarPipe implements PipeTransform {

  transform(tx: TransactionData): TransactionAvatar {
    if (tx.isFirstDrawOfLoan && tx.originalLoanId !== tx.loanId) {
      return { letter: 'R', cssClass: 'mat-indigo-bg', tooltip: 'First draw on renewal' };
    }
    if (tx.isFirstDrawOfLoan) {
      return { letter: '1', cssClass: 'mat-indigo-bg', tooltip: 'First draw' };
    }
    if (this.isManualPayment(tx)) {
      return this.getManualPaymentAvatar(tx);
    }
    return { letter: this.getTypeLetter(tx.type), cssClass: 'mat-light-grey-bg' };
  }

  // Null initiator counts as System (scheduled), matching backend IsSystem.
  private isManualPayment(tx: TransactionData): boolean {
    return tx.type === TransactionType.Payment
      && tx.initiatorType != null
      && tx.initiatorType !== InitiatorType.System;
  }

  // Who recorded it comes from the creator; the initiator is whoever requested it.
  private getManualPaymentAvatar(tx: TransactionData): TransactionAvatar {
    switch (tx.creatorType) {
      case InitiatorType.BackOfficeUser:
        return {
          letter: 'MI',
          cssClass: 'mat-darkblue-bg two-letters',
          tooltip: this.getRecordedTooltip('Idea Financial', tx.creator),
          tooltipClass: 'multiline-tooltip'
        };
      case InitiatorType.Customer:
        return {
          letter: 'MC',
          cssClass: 'mat-dark-teal-bg two-letters',
          tooltip: this.getRecordedTooltip('customer', tx.creator),
          tooltipClass: 'multiline-tooltip'
        };
      default:
        return { letter: 'M', cssClass: 'mat-darkblue-bg', tooltip: 'Manual payment' };
    }
  }

  private getRecordedTooltip(recordedBy: string, creator?: string): string {
    const origin = `Manual payment · recorded by ${recordedBy}`;
    const name = creator?.trim();
    return name ? `${origin}\nCreated by ${name}` : origin;
  }

  private getTypeLetter(type: TransactionType): string {
    switch (type) {
      case TransactionType.Draw:
        return 'D';
      case TransactionType.Payment:
        return 'P';
      case TransactionType.BalanceTransfer:
        return 'B';
      case TransactionType.Fee:
        return 'F';
      case TransactionType.Premium:
        return '$';
      case TransactionType.Reversal:
        return 'R';
      case TransactionType.BalanceAdjustment:
        return 'A';
      default:
        return '';
    }
  }
}
